<template>
	<div class="article" :class="desktop ? article.animation : 'fadeInUp'">
		<a :href="article.url" class="article-link" rel="noopener nofollow" target="_blank">
			<div class="article-img" v-bind:style="{ backgroundImage: 'url(' + imagePath + ')' }"></div>
			<div class="article-text" :class="$i18n.locale">
				<h3 v-html="article.title"></h3>
				<p v-html="article.body"></p>
			</div>
		</a>
		<div class="article-share">
			<div class="share-text" v-html="$t('Article.share')"></div>
			<SocialNetworks :url="article.url"></SocialNetworks>
		</div>
	</div>
</template>

<script>
	import SocialNetworks from '../partials/SocialNetworks.vue'
	export default {
		name: 'Social',
		props: ['article'],
		data() {
			return {
				desktop: true,
			}
		},
		components: {
			SocialNetworks,
		},
		computed: {
			imagePath() {
				return require('../../assets/img/' + this.article.image)
			},
		},
		created() {
			if (window.innerWidth < 768) {
				this.desktop = false
			}
		},
	}
</script>

<style scoped lang="scss">
	.article {
		width: 33.3333%;
		padding: 0 1.5%;
	}

	.article-img {
		height: 280px;
		background-size: cover;
		background-position: center center;
		position: relative;

		@include nomobile {
			&::after {
				transition: transform 0.3s ease;
				transform-origin: left;
				content: '';
				height: 6px;
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				transform: scaleX(0);
				background: $yellowTheme;
			}
		}
	}

	.article-text {
		color: $blueTheme;
		min-height: 130px;

		&.fr {
			margin-bottom: 30px;
		}

		// NO MOBILE
		@include nomobile {
			&.fr {
				min-height: 364px;
			}
		}

		h3 {
			font-size: 30px;
			line-height: 1.2;
			margin-top: 30px;
		}

		p {
			@extend %montserrat;
			color: $black;
			font-size: 17px;
			line-height: 28px;
			margin-top: 20px;
			text-align: left;
		}
	}

	.article-link {
		&:hover,
		&:focus {
			.article-img {
				&::after {
					transform: scaleX(1);
				}
			}
		}
	}

	.article-share {
		@include flex-container;
		margin-top: 30px;

		.share-text {
			@extend %lato-bold;
			color: $black;
			font-size: 18px;
			line-height: 50px;
			margin-right: 10px;
		}
	}

	@include littleMaxDesktop {
		.article-text {
			h3 {
				font-size: 26px;
			}
		}

		.article-share {
			.share-text {
				line-height: 30px;
			}
		}

		.article-img {
			height: 200px;
		}
	}

	@include mobile {
		.article {
			margin-top: 40px;
			width: 100%;

			&:first-child {
				margin-top: 0;
			}
		}

		.article-img {
			height: 60vw;
		}

		.article-share {
			.share-text {
				line-height: 50px;
			}
		}
	}
</style>
